import { useContext, createContext } from 'react';
import {
  type UserData,
  type Currency,
  type PaymentSettingsNavigationConfig,
} from '../types';
import { type Breakpoint } from '../constants';

export interface Config {
  accountLocale?: string;
  locale: string;
  timezone?: string;
  regionalFormat?: string;
  accountRegionalFormat?: string;
  instance?: string;
  isMobile?: boolean;
  currency?: Currency;
  paymentSettingsNavigationConfig?: PaymentSettingsNavigationConfig;
  atlasBaseUrl?: string;
  breakpoint?: Breakpoint;
  userData?: UserData;
  compId?: string;
  isPreview?: boolean;
  isEditor?: boolean;
  isComposer?: boolean;
  isRTL?: boolean;
  enableAnimations?: boolean;
}

export const ConfigContext = createContext<Config | null>(null);

export function useConfig() {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigContext.Provider');
  }

  return context || { locale: 'en', regionalFormat: 'en' };
}
